import { httpGet, httpPost, httpPostRaw, httpPut } from "@eres/rest";
import { LocaleUtil } from "@eres/core";
import cfg from "./config";
import { ENocMLookUp, ENocMollakData, Mode, TabuPerson } from "./entities";
import { TabuMobileConfig } from "@10x/tabu-mobile-api";

const integrationApi = "internal/integration/";
const dedApi = "ded/";

export function loadLookUp( lookUp: ENocMLookUp ) {
	return httpGet( cfg.enocMAPI().endPoint() + integrationApi + "lookup/" + `${ lookUp }` ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function getPropertyOwners( lookUp: ENocMLookUp, tabuPropertyId: number ) {
	return httpGet( cfg.enocMAPI().endPoint() + integrationApi + "lookup/" + `${ lookUp }` + "?parentId=" + `${ tabuPropertyId }` ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function getENocMollakRequest( requestId: string ) {
	return httpGet( cfg.enocMAPI().endPoint() + integrationApi + "noc/" + `${ requestId }` + "/detail" ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function getENocMollakRequests( ownerNumber: number ) {
	return httpGet( cfg.enocMAPI().endPoint() + integrationApi + "noc/list?ownerNumber=" + `${ ownerNumber }` ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function validateFromDNRD( docType: number, docNumber: string ) {
	// return httpGet(cfg.tabuAPI().endPoint() + "api/Tabu/ValidatePersonFromDNRD?&documentType=" + docType + "&documentNumber=" + docNumber);
	return httpGet( TabuMobileConfig.tabuAPI().endPoint() + "Tabu/ValidatePersonFromDNRD?&documentType=" + docType + "&documentNumber=" + docNumber );
}

export function validateProperty( tabuPropertyId: number ) {
	return httpPost( cfg.enocMAPI().endPoint() + integrationApi + "noc/property/" + `${ tabuPropertyId }` + "/validate", undefined ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function isEnocMUploadUrl( url: string ): boolean {
	return ( url.startsWith( cfg.enocDocAPI().endPoint() ) );
}

export function submitENocMollakRequest( enoc: ENocMollakData, tabuPropertyId: number ) {
	if ( enoc.mode === Mode.EDIT ) {
		return httpPut( cfg.enocMAPI().endPoint() + integrationApi + "noc/" + `${ enoc.id }` + "/resubmit", enoc ).then( resp => {
			return checkValidationError( resp );
		} );
	} else {
		return httpPost( cfg.enocMAPI().endPoint() + integrationApi + "noc/property/" + `${ tabuPropertyId }` + "/submit", enoc ).then( resp => {
			return checkValidationError( resp );
		} );
	}
}

export function cancelNOCRequest( requestID: number ) {
	return httpPut( cfg.enocMAPI().endPoint() + integrationApi + "noc/" + `${ requestID }` + "/cancel", undefined ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function uploadDocument( file: File, categoryType: string, documentId: number ) {
	const data = new FormData();
	data.append( "document", file, file.name );
	return httpPostRaw( cfg.enocDocAPI().endPoint() + categoryType + "/0/" + documentId, data );
}

export function getDEDLicense( LicNumber: string ) {
	return httpGet( cfg.enocMAPI().endPoint() + dedApi + "search/" + LicNumber ).then( resp => {
		return checkValidationError( resp );
	} );
}

export function searchTabuPerson( eid: string ): Promise<TabuPerson | undefined> {
	return httpGet( cfg.tabuPersonAPI().endPoint() + `${ eid }` ).then( resp => {
		if ( resp && resp.ResponseEntity && resp.ResponseEntity.ParticipantId && resp.ResponseEntity.ParticipantId !== 0 ) {
			return Promise.resolve( resp.ResponseEntity as TabuPerson );
		} else {
			return Promise.reject();
		}
	} );
}

export function searchEIdaPerson( eid: string ) {
	return httpGet( cfg.enocMAPI().endPoint() + integrationApi + `dnrd/get/${ eid }` ).then( resp => {
		return checkValidationError( resp );
	} );
}

function checkValidationError( response: any, key: string = "validationErrorsList" ): Promise<any> {
	if ( response ) {
		if ( response.hasOwnProperty( key ) ) {
			let errors = response[ key ];
			if ( errors != undefined && Array.isArray( errors ) && errors.length > 0 ) {
				let message = errors.map( e => e.errorMessageSet ? LocaleUtil.getLocalValue( e.errorMessageSet ) : e.errorMessage ).join( "\n" ).trim();
				let errorNumbers = errors.filter( e => e.errorNumber === 410010 );
				return Promise.reject( {
					type: "ValidationError",
					response: response && response.response ? response.response : undefined,
					errors: errors,
					message: message,
					errorNumbers: errorNumbers,
				} );
			}
		}
	}
	if ( response.response ) return response.response;
	return response;
}
